import { Dispatch, SetStateAction, useEffect, useState } from 'react';

type LocalStorageState<Value> = [
  value: Value,
  setValue: Dispatch<SetStateAction<Value>>,
];

export function useLocalStorage<T>(
  storageKey: string,
  initialData?: undefined,
): LocalStorageState<T | undefined>;
export function useLocalStorage<T>(
  storageKey: string,
  initialData: T,
): LocalStorageState<T>;
export function useLocalStorage<T>(
  storageKey: string,
  initialData?: T,
): LocalStorageState<T | undefined> {
  const [local, setLocal] = useState(() => {
    try {
      const item = localStorage.getItem(storageKey);
      return item ? JSON.parse(item) : initialData;
    } catch {
      return initialData;
    }
  });

  useEffect(() => {
    localStorage.setItem(storageKey, JSON.stringify(local));
  }, [local, storageKey]);

  return [local, setLocal];
}
